import { Task, TaskStatus } from "@app/maintenance/components/task/task.model";

const tasks: Task[] = [
    new Task({
        id: 1,
        name: "Cleaning with rubbing alcohol",
        description: "Pocedure to clean tools with alcohol \r Step1 -> .............1..............................2.......................3...................4..............5  \r Lorem, ipsum dolor sit amet consectetur adipisicing elit. Labore quod reiciendis exercitationem adipisci repellat impedit? Debitis voluptas aspernatur nemo ducimus incidunt, excepturi fugit recusandae commodi nihil ex beatae consequuntur vero.",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 2,
        name: "Cleaning",
        description: "Pocedure to clean tools with alcohol \nStep1 -> ...",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 3,
        name: "Maintenance",
        description: "Pocedure to clean tools with alcohol \nStep1 -> ...",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 4,
        name: "Cleaning",
        description: "Pocedure to clean tools with alcohol \nStep1 -> ...",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 5,
        name: "Cleaning",
        description: "Pocedure to clean tools with alcohol \nStep1 -> ...",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 6,
        name: "Cleaning",
        description: "Pocedure to clean tools with alcohol \nStep1 -> ...",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 7,
        name: "Maintenance",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 8,
        name: "Maintenance",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 9,
        name: "Maintenance",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 4,
        name: "Cleaning",
        description: "Pocedure to clean tools with alcohol \nStep1 -> ...",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 5,
        name: "Cleaning",
        description: "Pocedure to clean tools with alcohol \nStep1 -> ...",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 6,
        name: "Cleaning",
        description: "Pocedure to clean tools with alcohol \nStep1 -> ...",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 7,
        name: "Maintenance",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 8,
        name: "Maintenance",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        status: TaskStatus.NEW
    }),
    new Task({
        id: 9,
        name: "Maintenance",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        status: TaskStatus.NEW
    }),
];

export default tasks;
